/**
 * INITIALE DE L'AVATAR — le PRÉNOM d'abord (R-12).
 *
 * Elle était tirée de l'adresse e-mail : sur un parc où presque tous les
 * comptes commencent par `admin@`, `agent@` ou `a.quelquechose@`, tout le monde
 * portait la même lettre. Un avatar qui ne distingue personne ne sert à rien.
 * On prend donc la première lettre du NOM affiché, et l'adresse ne sert plus
 * que de repli pour un compte sans nom.
 *
 * L-NAV-1 — partagée par le bandeau ET le pied du menu : le pied prenait
 * encore l'initiale de l'e-mail (« D ») quand le bandeau prenait celle du nom
 * (« H ») pour la même personne (inventaire IA-nav, constat 5).
 */
export function avatarInitial(name?: string | null, email?: string | null): string {
  const fromName = (name ?? '').trim().charAt(0)
  if (fromName) return fromName.toUpperCase()
  const fromEmail = (email ?? '').trim().charAt(0)
  return fromEmail ? fromEmail.toUpperCase() : '?'
}
